import React from 'react';

interface DelegateRadioButtonsProps {
  selectedAction: string;
  setSelectedAction: (value: string) => void;
  disabled: boolean;
  options: string[];
  hasDelegationStatement?: boolean;
}

const DelegateRadioButtons: React.FC<DelegateRadioButtonsProps> = ({
  selectedAction,
  setSelectedAction,
  disabled,
  options,
}) => {
  return (
    <div className="flex flex-col items-start my-8 max-w-fit mx-auto">
      {options.includes('revoke') && (
        <label className="flex items-center">
          <input
            type="radio"
            name="action"
            value="revoke"
            checked={selectedAction === 'revoke'}
            onChange={() => setSelectedAction('revoke')}
            className="mr-2"
            disabled={disabled}
          />
          Revoke delegation
        </label>
      )}
      {options.includes('selfDelegate') && (
        <label className="flex items-center mt-2">
          <input
            type="radio"
            name="action"
            value="selfDelegate"
            checked={selectedAction === 'selfDelegate'}
            onChange={() => setSelectedAction('selfDelegate')}
            className="mr-2"
            disabled={disabled}
          />
          Delegate to yourself
        </label>
      )}
      {options.includes('manualDelegation') && (
        <label className="flex items-center mt-2">
          <input
            type="radio"
            name="action"
            value="manualDelegation"
            checked={selectedAction === 'manualDelegation'}
            onChange={() => setSelectedAction('manualDelegation')}
            className="mr-2"
            disabled={disabled}
          />
          Manually enter Delegate
        </label>
      )}
      <label className="flex items-center mt-2">
        <input
          type="radio"
          name="action"
          value="find"
          checked={selectedAction === 'find'}
          onChange={() => setSelectedAction('find')}
          className="mr-2"
          disabled={disabled}
        />
        Find a delegate
      </label>
      {options.includes('view') && (
        <label className="flex items-center mt-2">
          <input
            type="radio"
            name="action"
            value="view"
            checked={selectedAction === 'view'}
            onChange={() => setSelectedAction('view')}
            className="mr-2"
            disabled={disabled}
          />
          View delegation statement
        </label>
      )}
      {options.includes('ask') && (
        <label className="flex items-center mt-2">
          <input
            type="radio"
            name="action"
            value="ask"
            checked={selectedAction === 'ask'}
            onChange={() => setSelectedAction('ask')}
            className="mr-2"
            disabled={disabled}
          />
          Ask for delegations
        </label>
      )}
    </div>
  );
};

export default DelegateRadioButtons;
